import NavigationSectionComponent from "./component";
import { StoryObj } from "@storybook/react";
import YayLogo from "@/lib/images/yay/logo.svg";
import ImageFreeTrial from "@/lib/images/freeTrial.png";

export default {
  component: NavigationSectionComponent,
  title: "Layout/Navbar Section",
};

export const Default: StoryObj<typeof NavigationSectionComponent> = {
  args: {
    branding: {
      src: YayLogo as any,
      alt: "Yay.com",
    },
    available_trial: true,
    categories: [
      {
        label: "Voice",
        links: [
          {
            label: "Compare Voice Plans",
            description:
              "Explore our flexible phone system plans and features.",
            url: "/voice",
            title: "Compare VoIP Plans and Features",
          },
          {
            label: "Voice Features",
            description:
              "Discover our powerful, professional business phone system features.",
            url: "/voice/business-phone-system",
            title: "View VoIP Features",
          },
          {
            label: "Call Costs",
            description:
              "View the savings available on local & international calls with VoIP.",
            url: "/voice/calls",
            title: "View Business VoIP Call Costs",
          },
          {
            label: "Business Phone Systems",
            description:
              "Get the right phone system for your small business, startup, or enterprise.",
            url: "/business-phone-system",
            title: "View Our Business VoIP Phone System",
          },
          {
            label: "Chat Features",
            description:
              "Connect your teams and collaborate with business instant messaging.",
            url: "/app/business-instant-messaging",
            title: "View Business Instant Messaging Features",
          },
          {
            label: "Hosted Voice Reseller",
            description:
              "Start selling VoIP and telecoms via our custom reseller platform.",
            url: "/reseller",
            title: "Become a Hosted VoIP Reseller",
          },
        ],
        featureBoxInfo: {
          label: "Start Your Free 14 Day Trial Today",
          description: "Try our phone system and all our features for free.",
          image: {
            src: ImageFreeTrial,
            alt: "14 Day Free VoIP Trial",
          },
          url: "/voip/try-free",
        },
      },
      {
        label: "Phone Numbers",
        links: [
          {
            label: "All Phone Numbers",
            url: "/phone-number/all-numbers",
            title: "Choose and buy local and non-geographic phone numbers.",
          },
          {
            label: "London 020 Numbers",
            url: "/phone-number/020-london",
            title:
              "Buy 020 phone numbers for Central London and surrounding boroughs.",
          },
          {
            label: "Edinburgh 0131 Numbers",
            url: "/phone-number/0131-edinburgh",
            title: "Buy 0131 phone numbers for a local presence in Edinburgh.",
          },
          {
            label: "Transfer Your Phone number",
            url: "/phone-number/keep-my-number",
            title:
              "Port-in your existing phone numbera to use with our phone system.",
          },
          {
            label: "Birmingham 0121 Numbers",
            url: "/phone-number/0121-birmingham",
            title: "Buy 0121 phone numbers for a local presence in Birmingham.",
          },
          {
            label: "Liverpool 0151 Numbers",
            url: "/phone-number/0151-liverpool",
            title: "Buy 0151 phone numbers for a local presence in Liverpool.",
          },
          {
            label: "International Phone Numbers",
            url: "/phone-number/international",
            title:
              "View and buy international phone numbers for a global presence.",
          },
          {
            label: "Leeds 0113 Numbers",
            url: "/phone-number/0113-leeds",
            title: "Buy 0113 phone numbers for a local presence in Leeds.",
          },
          {
            label: "Manchester 0161 Numbers",
            url: "/phone-number/0161-manchester",
            title: "Buy 0161 phone numbers for a local presence in Manchester.",
          },
          {
            label: "Mobile Phone Numbers",
            url: "/phone-number/mobile",
            title: "Buy 07 phone numbers for a flexible UK presence.",
          },
          {
            label: "Glasgow 0141 Numbers",
            url: "/phone-number/0141-glasgow",
            title: "Buy 0141 phone numbers for a local presence in Glasgow.",
          },
        ],
      },
      {
        label: "Downloads",
        link: "/app",
      },
      {
        label: "Integrations",
        links: [
          {
            label: "Phone System Integrations",
            title: "View Business Phone System Integrations",
            description:
              "Combine our phone system with the CRM and apps you already use.",
            url: "/voice/integrations/",
          },
          {
            label: "VoIP API Docs",
            title: "View VoIP API Documentation",
            description:
              "Integrate VoIP and voice calling functionality with your own systems.",
            url: "/voip/api-docs/",
          },
          {
            label: "Microsoft Teams Direct Routing",
            title: "Integrate Microsoft Teams via Direct Routing",
            description:
              "Boost Microsoft Teams and reduce call costs with Direct Routing.",
            url: "/voice/integrations/microsoft-teams-direct-routing/",
          },
          {
            label: "Domain Name API Docs",
            title: "View Domain Name API Documentation",
            description:
              "Integrate domain registration tools with your own site and systems.",
            url: "/domain-names/api-docs/",
          },
        ],
      },
      {
        label: "Domain Names",
        links: [
          {
            label: "Domain Name Search",
            title: "Search for Domain Names",
            description:
              "Search for available domains for your latest business or personal project",
            url: "/domain-names/",
          },
          {
            label: "Domain Transfer",
            title: "Transfer Your Domain",
            description:
              "Transfer your domain names for less. Seamless single or bulk domain transfers.",
            url: "/domain-names/transfer-bulk/",
          },
          {
            label: "Domain Backorders",
            title: "Backorder Domain Names",
            description:
              "Register newly expiring domain names when they're due to drop.",
            url: "/domain-names/backorder/",
          },
          {
            label: "Domain Registration Pricing",
            title: "View Domain Registration Pricing",
            description:
              "Register domains for the best prices. View our domain name pricing.",
            url: "/domain-names/pricing/",
          },
          {
            label: "Bulk Domain Name Search",
            title: "Bulk Domain Name Search",
            description:
              "Save time by registering the domain names you want in bulk.",
            url: "/domain-names/bulk-search/",
          },
          {
            label: "Domain Name Features",
            title: "View Domain Name Features",
            description:
              "Clever features to help make managing your domain names easier.",
            url: "/domain-names/registration/",
          },
          {
            label: "Reseller Domain Names",
            title: "Find Out About Reseller Domain Names",
            description:
              "Find out how you can start reselling domains to your existing customers.",
            url: "/reseller/domains/",
          },
        ],
      },
      {
        label: "Help & About",
        links: [
          {
            label: "About Us",
            title: "Learn about Yay.com",
            description:
              "Learn why you should choose us as your telecoms provider.",
            url: "/about/",
          },
          {
            label: "Policies & Accreditations",
            title: "View Accreditations & Policies",
            description:
              "View our global accreditations and see why we’re the provider to trust.",
            url: "/about/accreditations/",
          },
          {
            label: "Reviews",
            title: "View Reviews and Testimonials",
            description:
              "Learn why we are loved by businesses around the world.",
            url: "/about/reviews/",
          },
          {
            label: "Frequent Questions",
            title: "Frequently Asked VoIP and Domain Questions",
            description:
              "Get answers to all the popular VoIP, domain and telecoms questions.",
            url: "/faq/",
          },
          {
            label: "Free Phone System Webinar",
            title: "Learn About Our Phone System",
            description: "Join a free walkthrough of our Cloud phone system.",
            url: "/webinar/",
          },
          {
            label: "Read Our Blog",
            title: "Read Our VoIP Blog",
            description:
              "Get the latest VoIP and telecoms tips, views and resources.",
            url: "/blog/",
          },
          {
            label: "VoIP News",
            title: "Read the Latest VoIP Industry News",
            description: "Read the latest VoIP and telecoms news for business.",
            url: "/news/",
          },
          {
            label: "Contact Us",
            title: "Contact Yay.com",
            description:
              "Get in touch with any questions or quotes you may require.",
            url: "/about/contact-us/",
          },
        ],
      },
    ],
  },
};
